module.exports = __webpack_public_path__ + "img/23a58f2.png";